import React from "react"
import { last, get, findIndex } from "lodash"
import { Form } from "antd"
import { QuestionPane } from "../Panes"
import Question from "../Question"
import { FormNavigationContext } from "../Panes/Form"

/**
 * A QuestionGroup contains mulitple questions
 * Apart from that it can also have a url, that should be called with the data,
 * once the QuestionGroup was completed.
 * Further more the questionGroup can have a result that will be stored with the QuestionGroup's
 * identifier.
 * The Result can come from
 *  a. The Requested URl
 *  b. A Mahtematical Operation
 */

export class QuestionGroup extends React.Component {
  state = {
    fields: { ...this.context.result },
    visibleIds: [],
  }

  static getDerivedStateFromProps(props, state) {
    return {
      ...state,
      groups: props.questions
        .reduce(
          (questionGroups, question) => {
            if (
              question.__typename === "SanityPageBreak" &&
              question.active !== false
            ) {
              questionGroups.push([])
            } else {
              last(questionGroups).push(question)
            }

            return questionGroups
          },
          [[]]
        )
        .filter(groups => groups.length > 0),
    }
  }

  groupIndexForIdentifier(activeIdentifier) {
    const groupsIdentifier = this.state.groups.map(group => {
      return group.map(({ question }) => get(question, "identifier", ""))
    })
    return findIndex(
      groupsIdentifier,
      groupIdentifiers => groupIdentifiers.indexOf(activeIdentifier) > -1
    )
  }

  // Being called when back is being triggered
  back() {
    if (this.groupIndexForIdentifier(this.context.activeIdentifier) > -1) {
      this.context.goBack()
    }
  }

  // Being called when back is being triggered
  next() {
    const groupIndex = this.groupIndexForIdentifier(
      this.context.activeIdentifier
    )
    const isLoadingScreen = get(this.state.groups, groupIndex, []).reduce(
      (isPreviousALoadingElement, currentQuestion) => {
        return (
          isPreviousALoadingElement ||
          currentQuestion.__typename.toLowerCase().indexOf("loading") > -1
        )
      },
      false
    )
    if (!isLoadingScreen && groupIndex > -1) {
      this.onSubmit(this.context.activeIdentifier)
    }
  }

  navigateTo = (identifier, shouldSkipValidation = false) => {
    this.onSubmit(
      this.context.activeIdentifier,
      identifier,
      shouldSkipValidation
    )
    // if (this.containsIdentifier(this.context.activeIdentifier)) {
    //   this.onSubmit(this.context.activeIdentifier)
    // }
  }

  onSubmit = (identifier, targetIdentifier, skipValidation) => {
    if (get(identifier, "preventDefault")) {
      identifier.preventDefault()
    }

    const groupsIdentifier = this.state.groups.map(group => {
      return group.map(({ question }) => get(question, "identifier", ""))
    })
    const submittedQuestionPaneIndex = findIndex(
      groupsIdentifier,
      groupIdentifiers => groupIdentifiers.indexOf(identifier) > -1
    )

    if (skipValidation && targetIdentifier) {
      this.context.goToIdentifier(targetIdentifier)
      return
    }

    // Validate whether currently active QuestionPane is valid
    this.props.form.validateFields(
      groupsIdentifier[submittedQuestionPaneIndex],
      (errors, values) => {
        if (errors != null) {
          if (typeof window !== `undefined`) {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }
          return
        }

        console.log("errors, values", errors, values)

        if (targetIdentifier) {
          this.context.goToIdentifier(targetIdentifier)
        }
        // Either go to next QuestionPane of this QuestionGroup or trigger QuestionGroup evaluation and go to next.
        else if (groupsIdentifier.length - 1 > submittedQuestionPaneIndex) {
          const nextQuestionPaneIndex = submittedQuestionPaneIndex + 1
          // Disable history for Loading screens
          const isLoadingScreen = this.state.groups[
            submittedQuestionPaneIndex
          ].reduce((isPreviousALoadingElement, currentQuestion) => {
            return (
              isPreviousALoadingElement ||
              currentQuestion.__typename.toLowerCase().indexOf("loading") === -1
            )
          }, false)

          this.context.goToIdentifier(
            groupsIdentifier[nextQuestionPaneIndex][0],
            isLoadingScreen
          )
        } else {
          this.context.processedQuestion(this.props.identifier, null)
        }
        this.context.setFields(values)
        this.setState({
          fields: {
            ...this.state.fields,
            ...values,
          },
        })
      }
    )

    // TODO also handle form changes during back navigation
    // TODO propagate form result up to Form
  }

  render() {
    return (
      <React.Fragment>
        <Form
          onSubmit={identifier => this.onSubmit(identifier)}
          style={{ display: "flex" }}
        >
          {this.state.groups.map(questionGroup => {
            const groupIdentifiers = questionGroup.map(({ question }) =>
              get(question, "identifier", "")
            )
            return (
              <QuestionPane
                key={groupIdentifiers.join("-")}
                identifiers={groupIdentifiers}
                paneWillShow={id => this.setState({ visibleIds: id })}
              >
                {questionGroup.map((question, index) => (
                  <Question
                    key={get(question, "question.identifier", "")}
                    {...question}
                    {...this.props.form}
                    onSubmit={identifier => this.onSubmit(identifier)}
                    navigateTo={this.navigateTo}
                    focus={
                      this.state.visibleIds.indexOf(
                        get(question, "question.identifier")
                      ) > -1 && index == 0
                    }
                    value={
                      this.context.result[
                        get(question, "question.identifier", "")
                      ] ||
                      this.state.fields[
                        get(question, "question.identifier", "")
                      ]
                    }
                  />
                ))}
              </QuestionPane>
            )
          })}
        </Form>
      </React.Fragment>
    )
  }
}

QuestionGroup.contextType = FormNavigationContext

export default Form.create({ name: "QuestionGroupForm" })(QuestionGroup)
